import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowUpFromLine: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm18 9-6-6-6 6' }],
    ['path', { d: 'M12 3v14' }],
    ['path', { d: 'M5 21h14' }],
  ],
];

export default ArrowUpFromLine;
